import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getCapexProgressAvailableColumns } from './api';

export const path = '/capex/progress/list';

const PageCapexProgress: React.FC = (props) => {
  const CapexProgress = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getCapexProgressAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <CapexProgress {...props} />;
};

export default PageCapexProgress;
